import { Input, InputProps } from "@chakra-ui/react";
import { useAuthStyles, UserRole } from "theme/hooks/useAuthStyles";

interface AuthInputProps extends Omit<InputProps, "sx"> {
  variant?: "normal" | "placeholder";
  borderRadius?: string;
  role?: UserRole;
  chakraVariant?: InputProps["variant"];
}

export const AuthInput = ({
  variant = "normal",
  role,
  isInvalid,
  chakraVariant,
  ...props
}: AuthInputProps) => {
  const authStyles = useAuthStyles(role);
  const inputStyles = isInvalid
    ? authStyles.input?.error
    : authStyles.input?.normal;
  const placeholderStyles = isInvalid
    ? authStyles.input?.placeholderError
    : authStyles.input?.placeholder;

  const useChakraVariant = !!chakraVariant;

  return (
    <Input
      {...(chakraVariant ? { variant: chakraVariant } : {})}
      fontSize={
        props.fontSize ?? (useChakraVariant ? undefined : inputStyles?.fontSize)
      }
      lineHeight={useChakraVariant ? undefined : inputStyles?.lineHeight}
      textAlign={useChakraVariant ? undefined : (inputStyles?.textAlign as any)}
      color={useChakraVariant ? undefined : inputStyles?.color}
      border={useChakraVariant ? undefined : inputStyles?.border}
      borderRadius={useChakraVariant ? undefined : inputStyles?.borderRadius}
      padding={useChakraVariant ? undefined : inputStyles?.padding}
      height={useChakraVariant ? undefined : inputStyles?.height}
      bgColor={useChakraVariant ? undefined : inputStyles?.bgColor}
      boxShadow={useChakraVariant ? undefined : inputStyles?.boxShadow}
      isInvalid={isInvalid}
      errorBorderColor="transparent"
      focusBorderColor="transparent"
      _invalid={
        useChakraVariant
          ? undefined
          : {
              border: inputStyles?.border,
              boxShadow: inputStyles?.boxShadow,
            }
      }
      _placeholder={{
        fontSize: useChakraVariant ? undefined : placeholderStyles?.fontSize,
        lineHeight: useChakraVariant
          ? undefined
          : placeholderStyles?.lineHeight,
        textAlign: useChakraVariant
          ? undefined
          : (placeholderStyles?.textAlign as any),
        color: "#505E70",
      }}
      {...props}
    />
  );
};
